import { render, staticRenderFns } from "./CrewCer.vue?vue&type=template&id=3015fa27&scoped=true&"
import script from "./CrewCer.vue?vue&type=script&lang=js&"
export * from "./CrewCer.vue?vue&type=script&lang=js&"
import style0 from "./CrewCer.vue?vue&type=style&index=0&id=3015fa27&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3015fa27",
  null
  
)

export default component.exports